module.exports = __webpack_public_path__ + "img/256x256_diamond.321c0394.svg";